import { render, staticRenderFns } from "./block-admin-users.vue?vue&type=template&id=476c8b72&scoped=true&lang=pug"
import script from "./block-admin-users.vue?vue&type=script&lang=js"
export * from "./block-admin-users.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c8b72",
  null
  
)

export default component.exports